import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import themes from '../../theming/themes.js';
import React, { memo } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';

var _excluded = ["backgroundColor", "children", "fontColor", "theme"];
var _templateObject;
var StyledDiv = styled__default('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  align-items: center;\n  border-radius: 16px;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: bold;\n  font: 1rem;\n  justify-content: flex-start;\n  padding: 5px 10px;\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'secondary' : _ref$backgroundColor;
  return theme.palette[backgroundColor];
}, function (_ref2) {
  var theme = _ref2.theme,
    _ref2$fontColor = _ref2.fontColor,
    fontColor = _ref2$fontColor === void 0 ? 'white' : _ref2$fontColor;
  return theme.palette[fontColor];
});
var Badge = function Badge(_ref3) {
  var backgroundColor = _ref3.backgroundColor,
    children = _ref3.children,
    fontColor = _ref3.fontColor,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes["default"] : _ref3$theme,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledDiv, _extends({
    backgroundColor: backgroundColor,
    className: 'm-1',
    fontColor: fontColor,
    theme: theme
  }, rest), children);
};
// @ts-ignore
var _Badge = withDefaultTheme(/*#__PURE__*/memo(Badge));

export default _Badge;
